import { render, staticRenderFns } from "./RipaSubheader.vue?vue&type=template&id=6b642104"
import script from "./RipaSubheader.vue?vue&type=script&lang=js"
export * from "./RipaSubheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports